const tools = require('../../tools')
const { listSuppliersForLocationIds } = require('./get-all-suppliers-batch')

exports.listWarehouseStock = listWarehouseStock
async function listWarehouseStock (
  state,
  mainApi,
  { locationId, programId, date } = {}
) {
  tools.validateParams('listWarehouseStock', arguments[2])

  const programShortId = programId.replace(/^program:/, '')
  const hasProgram = (locationDoc = {}) => {
    if (Array.isArray(locationDoc.programs)) {
      return locationDoc.programs.some(program => program.id === programId)
    }
    return !!(locationDoc.programs && locationDoc.programs[programShortId])
  }

  // Resolve the supplier warehouse for this location and program.
  const referenceDate = date || new Date().toJSON()

  // SL has a simplified supplier graph where facilities are mapped from market config docs, we will plug that in with a feature flag when needed.
  // NHLMIS locations have a supplier graph mapped across multiple zones/states across different virtual suppliers.
  // So we build a reduced location set destination SDP + zone/state locations (suppliers)
  // This avoids loading all location docs which slows down the function.
  const levelLocationIds = await state.dal.location.listIdsByLevels(state, ['zone', 'state'])
  const reducedLocationIds = Array.from(new Set([locationId, ...levelLocationIds]))
  const reducedLocations = await state.dal.location.getRawDocByIds(state, reducedLocationIds)

  // Pass relevant location docs to get relevant suppliers
  const reducedSuppliers = await listSuppliersForLocationIds(state, [locationId], { allLocations: reducedLocations })

  // Keep only suppliers that support the requested program.
  const warehouse = reducedSuppliers.find(hasProgram) || null
  if (!warehouse) {
    console.warn(`No warehouse found supplying location ${locationId} for program ${programId}`)
    return { locationId, programId, warehouseId: null, sellPrices: [], genericGroups: [] }
  }

  // Pull sell prices for the warehouse.
  const priceList = await mainApi.price.location.getSellPriceList(warehouse._id, referenceDate)
  const sellPrices = priceList.sellPrices || []
  const skus = Array.from(new Set(
    sellPrices.map(price => price.productId.replace('product:', ''))
  ))

  // Map sku -> generic_id in PG, then group by generic_id.
  const genericMetaBySku = await mainApi.product.productSKU.getGenericIdsForSkus(skus)

  // Group products by generic_id (generic parent), including sell price info for each product.
  const genericGroups = tools.groupWarehouseProductsByGenericId({
    sellPrices,
    genericMetaBySku
  })

  return {
    locationId,
    programId,
    warehouseId: warehouse._id,
    sellPrices,
    genericGroups
  }
}
